/* eslint-disable max-len */
import CollectionName from './collections';

const pathPlaceholder = {
  USER_ID: 'userId',
  COACH_ID: 'coachId',
  LEAD_ID: 'leadId',
  GAMEPLAY_SESSION_ID: 'gameplaySessionId',
  ACTIVITY_SESSION_ID: 'activitySessionId',
  WORKOUT_HISTORY_FRAME: 'workoutHistoryFrame',
  CUSTOM_WORKOUT_ID: 'customWorkoutId',
  FILE_NAME: 'fileName',
  COACH_NOTIFICATION: 'coachNotification',
  GAMEPLAY_SESSION_VIDEO_REQUEST: 'gameplaySessionVideoRequest',
  TRACKED_ACTIVITY_ID: 'trackedActivityId',
  RECIPE_ID: 'recipeId',
  WORKOUT_ID: 'workoutId',
  PRODUCT_ID: 'productId',
  CHANNEL_ID: 'channelId',
  WEEK: 'week',
};

const firestorePaths = {
  USER: `/${CollectionName.USER}`,
  USER_CONFIG: `/${CollectionName.CONFIG}`,
  GAMEPLAY_SESSION_COLLECTION: `/${CollectionName.GAMEPLAY_SESSION}`,
  USER_DEVICE: `/${CollectionName.USER_DEVICE}`,
  USER_ACTIVITY_HISTORY: `/${CollectionName.USER_ACTIVITY_HISTORY}`,
  EXERCISE: `/${CollectionName.EXERCISE}`,
  COACH: `/${CollectionName.COACH}`,
  TRACKED_ACTIVITY_SUMMARY: `/${CollectionName.TRACKED_ACTIVITY_SUMMARY}`,
  WORKOUT: `/${CollectionName.WORKOUT}`,
  WORKOUT_ASSIGNMENT: `/${CollectionName.WORKOUT_ASSIGNMENT}`,
  STREAK: `/${CollectionName.STREAK}`,
  TRACKED_ACTIVITY: `/${CollectionName.TRACKED_ACTIVITY}`,
  REFERRAL_CODE: `/${CollectionName.REFERRAL_CODE}`,
  APP_CUSTOMIZATION: `/${CollectionName.APP_CUSTOMIZATION}`,
  CHANGELOG: `/${CollectionName.CHANGELOG}`,
  MESSAGE_SUGGESTION: `/${CollectionName.MESSAGE_SUGGESTION}`,
  USER_CONTRACT: `/${CollectionName.USER_CONTRACT}`,
  CHECKOUT_SESSION_ONBOARDING: `/${CollectionName.CHECKOUT_SESSION_ONBOARDING}`,
  STRIPE: `/${CollectionName.INTEGRATIONS}/stripe`,
  FACEBOOK: `/${CollectionName.INTEGRATIONS}/facebook`,
};

firestorePaths.GAMEPLAY_SESSION_DOC = `${firestorePaths.GAMEPLAY_SESSION_COLLECTION}/{${pathPlaceholder.GAMEPLAY_SESSION_ID}}`;
firestorePaths.USER_DOC = `${firestorePaths.USER}/{${pathPlaceholder.USER_ID}}`;
firestorePaths.USER_CONFIG_DOC = `${firestorePaths.USER_CONFIG}/{${pathPlaceholder.USER_ID}}`;
firestorePaths.COACH_DOC = `${firestorePaths.COACH}/{${pathPlaceholder.COACH_ID}}`;
firestorePaths.ACTIVITY_SESSION_COLLECTION = `${firestorePaths.GAMEPLAY_SESSION_DOC}/ActivitySessions`;
firestorePaths.ACTIVITY_SESSION_DOC = `${firestorePaths.ACTIVITY_SESSION_COLLECTION}/{${pathPlaceholder.ACTIVITY_SESSION_ID}}`;
firestorePaths.WORKOUT_FRAMES_COLLECTION = `${firestorePaths.ACTIVITY_SESSION_DOC}/WorkoutFrames`;
firestorePaths.TRACKED_ACTIVITY_DOC = `${firestorePaths.TRACKED_ACTIVITY}/{${pathPlaceholder.TRACKED_ACTIVITY_ID}}`;
firestorePaths.STRIPE_PAYOUT_RECONCILIATION = `${firestorePaths.STRIPE}/payoutReconciliation`;
firestorePaths.FACEBOOK_PIXEL_CONFIG = `${firestorePaths.FACEBOOK}/pixelConfig`;

const storagePaths = {
  USER: 'user',
  CLIENT_DOCUMENTS: 'clientDocuments',
  BROADCAST_MESSAGES_ATTACHMENTS: 'broadcastMessagesAttachments',
  ANNOUNCEMENT_ATTACHMENTS: 'announcementAttachments',
  ANNOUNCEMENT_COMMENTS_ATTACHMENTS: 'announcementCommentsAttachments',
  RECIPE: 'recipe',
  COACH: 'coaches',
  FORM: 'form',
  APP_CUSTOMIZATION: 'appCustomization',
  CHECK_IN_FEEDBACK: 'checkinFeedback',
  CHAT: 'chat',
  COACH_TASK_ATTACHMENTS: 'coachTaskAttachments',
  RELEASE_NOTE: 'releaseNote',
};

storagePaths.USER_COLLECTION = `${storagePaths.USER}/{${pathPlaceholder.USER_ID}}`;
storagePaths.GAMEPLAY_SESSION_COLLECTION = `${storagePaths.USER_COLLECTION}/GameplaySessions`;
storagePaths.GAMEPLAY_SESSION_DOC = `${storagePaths.GAMEPLAY_SESSION_COLLECTION}/{${pathPlaceholder.GAMEPLAY_SESSION_ID}}`;
storagePaths.ACTIVITY_SESSION_COLLECTION = `${storagePaths.GAMEPLAY_SESSION_DOC}/ActivitySessions`;
storagePaths.ACTIVITY_SESSION_DOC = `${storagePaths.ACTIVITY_SESSION_COLLECTION}/{${pathPlaceholder.ACTIVITY_SESSION_ID}}`;
storagePaths.WORKOUT_HISTORY_FRAME = `${storagePaths.ACTIVITY_SESSION_DOC}/{${pathPlaceholder.WORKOUT_HISTORY_FRAME}}.jpg`;
storagePaths.CUSTOM_WORKOUT_COLLECTION = `${storagePaths.USER_COLLECTION}/customWorkout`;
storagePaths.CUSTOM_WORKOUT_DOC = `${storagePaths.USER_COLLECTION}/customWorkout/{${pathPlaceholder.CUSTOM_WORKOUT_ID}}`;
storagePaths.CUSTOM_WORKOUT_ATTACHEMENT = `${storagePaths.CUSTOM_WORKOUT_DOC}/{${pathPlaceholder.FILE_NAME}}`;
storagePaths.USER_IMAGES = `${storagePaths.USER}/{${pathPlaceholder.USER_ID}}/images`;
storagePaths.TRACKED_ACTIVITY_COLLECTION = `${storagePaths.USER_COLLECTION}/trackedActivity`;
storagePaths.TRACKED_ACTIVITY_DOC = `${storagePaths.TRACKED_ACTIVITY_COLLECTION}/{${pathPlaceholder.TRACKED_ACTIVITY_ID}}`;
storagePaths.TRACKED_ACTIVITY_ATTACHEMENT = `${storagePaths.TRACKED_ACTIVITY_DOC}/{${pathPlaceholder.FILE_NAME}}`;
storagePaths.COACH_BROADCAST_MESSAGES_ATTACHMENTS = `${storagePaths.BROADCAST_MESSAGES_ATTACHMENTS}/{${pathPlaceholder.COACH_ID}}`;
storagePaths.COACH_ANNOUNCEMENTS_ATTACHMENTS = `${storagePaths.ANNOUNCEMENT_ATTACHMENTS}/{${pathPlaceholder.COACH_ID}}`;
storagePaths.COACH_ANNOUNCEMENTS_COMMENTS_ATTACHMENTS = `${storagePaths.ANNOUNCEMENT_COMMENTS_ATTACHMENTS}/{${pathPlaceholder.COACH_ID}}`;
storagePaths.COACH_TASK_ATTACHMENTS_BY_COACH = `${storagePaths.COACH_TASK_ATTACHMENTS}/{${pathPlaceholder.COACH_ID}}`;
// A long-format session's raw video, keyed on the coach who owns the workout rather than whoever
// uploaded it — a CAM uploads on a coach's behalf into that coach's prefix.
storagePaths.LONG_SESSION_UPLOADS = `longSessionUploads/{${pathPlaceholder.COACH_ID}}/{${pathPlaceholder.WORKOUT_ID}}`;
storagePaths.WELCOME_VIDEO_UPLOADS = `welcomeVideoUploads/{${pathPlaceholder.COACH_ID}}/{${pathPlaceholder.PRODUCT_ID}}`;
storagePaths.RECIPE_COLLECTION = `${storagePaths.RECIPE}/{${pathPlaceholder.RECIPE_ID}}`;
storagePaths.COACH = `${storagePaths.COACH}/{${pathPlaceholder.COACH_ID}}`;
storagePaths.IS_MSG_ATTACHMENTS = `${storagePaths.COACH}/isMsgAttachments`;
storagePaths.COACH_LEAD_END_SCREEN = `${storagePaths.COACH}/leadEndScreen`;
storagePaths.COACH_WELCOME_MESSAGE_ATTACHMENTS = `${storagePaths.COACH}/welcomeMessageAttachments`;
storagePaths.COACH_LIBRARY_DOCUMENTS = `${storagePaths.COACH}/libraryDocuments`;
storagePaths.COACH_ONBOARDING_MESSAGE_ATTACHMENTS = `${storagePaths.COACH}/onboardingMessageAttachments`;
storagePaths.COACH_BIRTHDAY_MESSAGE_ATTACHMENTS = `${storagePaths.COACH}/birthdayMessageAttachments`;
storagePaths.CLIENT_JOURNEY_WEEKLY_MESSAGE_ATTACHMENTS = `${storagePaths.COACH_BROADCAST_MESSAGES_ATTACHMENTS}/clientJourneyWeeklyMessageAttachments/{${pathPlaceholder.WEEK}}`;
storagePaths.COACH_FORM_COLLECTION = `${storagePaths.FORM}/{${pathPlaceholder.COACH_ID}}`;
storagePaths.APP_CUSTOM_ICONS = `${storagePaths.APP_CUSTOMIZATION}/{${pathPlaceholder.COACH_ID}}/icons`;
storagePaths.CHAT_COLLECTION = `${storagePaths.CHAT}/{${pathPlaceholder.CHANNEL_ID}}`;
storagePaths.LEAD_CHAT_ATTACHMENTS = `leadChatAttachments/{${pathPlaceholder.LEAD_ID}}`;
storagePaths.CLIENT_DOCUMENTS_COLLECTION = `${storagePaths.CLIENT_DOCUMENTS}/{${pathPlaceholder.USER_ID}}`;
// Top level (not under coaches/) — challenge clients must be able to read the media.
storagePaths.COACH_UPSELL_MEDIA = `upsellMedia/{${pathPlaceholder.COACH_ID}}`;

export {
  firestorePaths,
  storagePaths,
  pathPlaceholder,
};
